<template>
  <van-field
    v-model="val"
    :type="type"
    :size="size"
    :label="label"
    :placeholder="placeholder || label"
    :required="required"
    :rules="rules"
    :readonly="readonly"
    :clearable="clearable"
    :disabled="disabled"
    :maxlength="maxlength"
    @input="change"
  >
    <template #button>
      <slot name="button" />
    </template>
  </van-field>
</template>
<script>
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    type: {
      type: String,
      default: 'text'
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'small'
    },
    value: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: function() {
        return [{ required: this.required, message: '请输入' + this.label }]
      }
    },
    maxlength: {
      type: String
    }
  },
  data() {
    return {
      val: this.value
    }
  },
  watch: {
    value: function(value) {
      this.val = value
    }
  },
  methods: {
    change(value) {
      this.$emit('change', value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/base/BaseInput.vue